import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"
import { module as BaseModule } from "modujs"

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  fade() {
    gsap.to(this.el, {
      autoAlpha: 1,
      duration: 1,
      ease: "power2.inOut",
    })
  }

  intro() {
    const gradient = this.el.querySelector(".gradient")
    const tl = gsap.timeline({ paused: true })
    tl.fromTo(
      this.el,
      {
        backgroundColor: "#000",
        color: "#fff",
      },
      {
        backgroundColor: "#F4F4F4",
        color: "#F4F4F4",
        duration: 1,
      },
    )

    if (gradient) {
    tl.fromTo(
      gradient,
      {
        "--tw-gradient-from": "#000",
      },
      {
        "--tw-gradient-from": "#F4F4F4",
        duration: 1,
      },
      "0",
    )
  }

    ScrollTrigger.create({
      trigger: this.el,
      start: "50% 25%",
      end: "bottom 25%",
      animation: tl,
      scrub: true,
    })
  }

  text() {
     ScrollTrigger.create({
      trigger: this.el,
      start: "top bottom",
      end: "bottom top",
      once: true,
      onEnter: () => {
        const texts = this.el.querySelectorAll(".text")
        texts.forEach((text) => {
          this.textInstantAnimation(text)
        })
      }
    })
  }

  textinstant() {
    const texts = this.el.querySelectorAll("p")

    document.fonts.ready.then(() => {
      texts.forEach((text) => {
        this.textInstantAnimation(text)
      })
    })
  }

  textInstantAnimation(text) {
    gsap.set(text, { opacity: 1 })

    let split
    SplitText.create(text, {
      type: "lines",
      autoSplit: true,
      mask: "lines",
      onSplit: (self) => {
        split = gsap.from(self.lines, {
          opacity: 0,
          stagger: 0.15,
          duration: 1.5,
        })
        return split
      },
    })
  }
}
